import {
  ApplicationConfig,
  APP_INITIALIZER,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAuth0 } from '@auth0/auth0-angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { installPaymentTokenizer } from './services/payments/tokenizer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: environment.auth0.redirect_uri,
        audience: environment.auth0.audience,
        scope: 'openid profile email offline_access',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.api.replace(/\/$/, '')}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0.audience,
                // request API scopes only when calling your API:
                scope:
                  'ticket:view ticket:payment:create vehicles:create users:admin offline_access',
              },
            },
          },
        ],
      },
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => () => {
        try {
          installPaymentTokenizer();
        } catch {
          /* no-op */
        }
      },
    },
  ],
};
